<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        color="success"
        v-on="on"
      >
        Create Task Category
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Task Category"
      text="Create Task Category"
      class="mb-0"
    > 
      <form v-if="!loading">
        <v-container v-if="dialog">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Task Category Name"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        loading: false,
        dialog: false,
        name: '',
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.resetForm()
        }
      },
    },
    methods: {
      prepareFormData () {
        return {
          name: this.name,
        }
      }, 
      submitForm () {
        this.$validator.validateAll().then(result => {
          if (!result) return 
          this.$api.taskCategories().create(this.prepareFormData())
            .then((res) => {
              if (res.status === 201) {
                this.$emit('created')
                this.$snack({ message: 'Task category added successfully' })

                this.dialog = false
              }
            })
            .catch(() => {
              this.$snack({ 
                color: 'error',
                message: 'Failed to create task category',
              })
            })
        })
      },
      resetForm () {
        this.name = ''
        this.$validator.reset()
      },
    },
  }
</script>
